import {createStore} from 'vuex'
import {authStore} from "@/store/modules/auth";
import {LoadingStore} from "@/store/modules/loading";
import createPersistedState from "vuex-persistedstate"

export default createStore({
    modules: {
        authStore,
        LoadingStore
    },
    plugins: [
        createPersistedState({
            storage: window.sessionStorage,
            paths: ["AuthStore"],
            key: "innost-web-view"
        })
    ]
})
